/*
 * Module for an kbTouchpoint item
 */
define([
  "backbone",
  "underscore",
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/accountAdmin/kbWizardModal/kbTouchPoints/kbTouchPointsView",
  "modules/accountAdmin/kbAdmin/kbModel",
  "modules/shared/sortableList/sortableListModule",
  "modules/accountAdmin/kbWizardModal/kbResponseTypeUsage/kbResponseTypeUsageModule",
], function (
  Backbone,
  _,
  Marionette,
  $,
  Messenger,
  KbTouchPointsView,
  KbModel,
  SortableListModule,
  KbResponseTypeUsageModule,
) {
  var KbTouchPointsModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "kbTouchPoints";
      this.region = options.region;
      this.editMode = options.editMode;
      this._setUpVents();
    },

    show: function (kb) {
      this.kb = kb;

      this.layout = new KbTouchPointsView.kbTouchPointsLayout({
        model: this.kb,
      });

      this.touchPoints = this.kb.getTouchPoints();
      var headers = Messenger.reqres.request("kb:touchPoints:list:headers");

      var extendedEvents = {
        "click .deleteKbTouchPoint": function () {
          this.model.deleteModel();
          Messenger.vent.trigger("clear:touchPoint:errors");
          Messenger.vent.trigger("fetch:kb:responseTypeUsage:touchpoint:change:decrease");
        },
      };

      this.list = this.addSubModule(
        new SortableListModule({
          region: this.layout.list,
          headers: headers,
          namespace: this.name,
          extendedEvents: extendedEvents,
          hideHeader: true,
          hideControls: true,
        }),
      );

      this.responseTypeUsageView = this.addSubModule(
        new KbResponseTypeUsageModule({
          region: this.layout.responseTypeUsage,
          editMode: this.editMode,
        }),
      );

      this.layout.on(
        "show",
        function () {
          this.responseTypeUsageView.show(kb);
          this.list.show(this.touchPoints);
        },
        this,
      );

      this.layout.on(
        "addTouchPoint",
        function () {
          this.addTouchPoint(this.layout.getTouchPoint());
        },
        this,
      );

      this.touchPoints.onSynced(function () {
        this.showRegion(this.layout);

        //If this is a new KB, add a 'Default' touchPoint
        if (!this.editMode && this.touchPoints.length === 0) {
          this.addTouchPoint("Default");
        }
      }, this);
    },

    addTouchPoint: function (touchPointName) {
      var _this = this;
      var newTouchPoint = this.touchPoints.addItem(touchPointName);
      newTouchPoint.on(
        "invalid",
        function (model, error) {
          this.layout.clearErrors();
          if (error["touchPoint"]) {
            this.layout.touchPointError(error["touchPoint"]);
            newTouchPoint.deleteModel();
          }
        },
        this,
      );

      if (this.editMode) {
        newTouchPoint.saveModel({
          success: function () {
            _this.layout.clearErrors();
            _this.layout.clearTouchPoint();
            Messenger.vent.trigger("fetch:kb:responseTypeUsage:touchpoint:change:increase");
          },
          error: function (model, response) {
            newTouchPoint.deleteModel();
            if (response.status === 400) {
              Messenger.okDialog(
                $.t("admin.kbAdmin.addTouchPointError", { message: response.responseJSON.value }),
              );
            } else {
              Messenger.showErrorFromResponse(response);
            }
          },
        });
      } else {
        if (newTouchPoint.isValid()) {
          _this.layout.clearErrors();
          _this.layout.clearTouchPoint();
          Messenger.vent.trigger("fetch:kb:responseTypeUsage:touchpoint:change:increase");
          if (!this.responseTypeUsageView.responseTypeUsageValid()) {
            newTouchPoint.deleteModel();
            Messenger.vent.trigger("fetch:kb:responseTypeUsage:touchpoint:change:decrease");
            Messenger.okDialog("admin.kbAdmin.kbCreationTouchpointResponseTypeUsageInvalid");
          }
        }
      }
    },

    getKb: function () {
      return this.kb;
    },

    isValid: function () {
      if (this.touchPoints.length === 0) {
        this.layout.clearErrors();
        this.layout.touchPointError($.t("admin.kbAdmin.emptyTouchPointListError"));
        return false;
      } else {
        return true;
      }
    },

    _setUpVents: function () {
      Messenger.vent.on(
        "clear:touchPoint:errors",
        function () {
          this.layout.clearErrors();
        },
        this,
      );
    },
  });

  return KbTouchPointsModule;
});
